import { computeFieldValue } from "scenes/Hubly/components/Workspace/api";

import { createResolverFactory } from ".";

export function updateForm() {
  const query = `mutation updateForm($id: ID!, $formName: String!) {
        updateForm(formId: $id, formName: $formName) {
          form {
            uuid
            name
            fields {
              edges {
                node {
                  id
                  name
                  options
                  type {
                    id
                    text
                    showOptions
                  }
                  dataType
                  required
                  description
                  defaultValue {
                    ... on StringValue {
                      stringValue
                    }
                    ... on BooleanValue {
                      booleanValue
                    }
                    ... on DateTimeValue {
                      datetimeValue
                    }
                    ... on ArrayStringValue {
                      arrayStringValue
                    }
                  }
                }
              }
            }
          }
        }
      }`;

  const resolver = ({ data }) => {
    return {
      data: {
        ...data?.updateForm?.form,
        fields: data?.updateForm?.form?.fields.edges.map(
          ({ node: fieldNode }) => {
            return {
              ...fieldNode,
              defaultValue: computeFieldValue(
                fieldNode.defaultValue,
                fieldNode.dataType
              ),
            };
          }
        ),
      },
    };
  };

  return { query: query, resolver: createResolverFactory(resolver) };
}

export function deleteForm() {
  const query = `mutation deleteForm($formId: ID!) {
        deleteForm(formId: $formId) {
          success
        }
      }`;

  const resolver = ({ data }) => {
    return data?.deleteForm;
  };

  return { query: query, resolver: createResolverFactory(resolver) };
}

export function createFormField() {
  const query = `mutation createFormField($field: FieldInput!, $taskId: ID!, $placeBeforeItemId: ID, $formName: String) {
        createFormField(field: $field, taskId: $taskId, placeBeforeItemId: $placeBeforeItemId, formName: $formName) {
          form {
            id
            name
            fields {
              edges {
                node {
                  id
                  name
                  options
                  type {
                    id
                    text
                    showOptions
                  }
                  dataType
                  required
                  description
                  defaultValue {
                    ... on StringValue {
                      stringValue
                    }
                    ... on BooleanValue {
                      booleanValue
                    }
                    ... on DateTimeValue {
                      datetimeValue
                    }
                    ... on ArrayStringValue {
                      arrayStringValue
                    }
                  }
                }
              }
            }
          }
        }
      }`;

  const resolver = ({ data }) => {
    return {
      data: {
        ...data?.createFormField?.form,
        fields: data?.createFormField?.form?.fields.edges.map(
          ({ node: fieldNode }) => {
            return {
              ...fieldNode,
              defaultValue: computeFieldValue(
                fieldNode.defaultValue,
                fieldNode.dataType
              ),
            };
          }
        ),
      },
    };
  };
  return { query: query, resolver: createResolverFactory(resolver) };
}

export function updateFormField() {
  const query = `mutation updateFormField($field: FieldInput!, $id: ID!) {
        updateFormField(field: $field, fieldId: $id) {
          field {
            id
            name
            options
            type {
              id
              text
              showOptions
            }
            dataType
            required
            description
            defaultValue {
              ... on StringValue {
                stringValue
              }
              ... on BooleanValue {
                booleanValue
              }
              ... on DateTimeValue {
                datetimeValue
              }
              ... on ArrayStringValue {
                arrayStringValue
              }
            }
          }
        }
      }`;

  const resolver = ({ data }) => {
    const field = data?.updateFormField?.field;
    return {
      data: {
        ...field,
        defaultValue: computeFieldValue(field.defaultValue, field.dataType),
      },
    };
  };

  return { query: query, resolver: createResolverFactory(resolver) };
}

export function deleteFormField() {
  const query = `mutation deleteFormField($fieldId: ID!) {
        deleteFormField(fieldId: $fieldId) {
          success
        }
      }`;

  const resolver = ({ data }) => {
    return { data: data?.deleteFormField };
  };

  return { query, resolver };
}

export function updateFormFieldSortOrder() {
  const query = ` mutation updateFormFieldSortOrder($targetId: ID!, $placeBeforeItemId: ID) {
    updateFormFieldSortOrder(targetId: $targetId, placeBeforeItemId: $placeBeforeItemId) {
      success
    }
  }`;

  const resolver = ({ data }) => {
    return data?.updateFormFieldSortOrder?.success;
  };

  return { query: query, resolver: createResolverFactory(resolver) };
}
